module.exports = __webpack_public_path__ + "img/bory-exit-modal.4bd05862.jpg";